import {usePatientTherapySequenceContext} from '@/shared/contexts/patient-therapy-sequence-context'
import {Badge, Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

export function PatientTherapySequenceTabsList() {
  const {t} = useTranslate('common')
  const {sequence} = usePatientTherapySequenceContext()

  return (
    <Tabs.List minWidth="max-content" border="none">
      <Tabs.Trigger value="about" data-e2e="about-trigger">
        {t('about')}
      </Tabs.Trigger>

      {sequence.protocolId && (
        <Tabs.Trigger value="protocol" data-e2e="protocol-trigger">
          {t('protocol')}
        </Tabs.Trigger>
      )}

      <Tabs.Trigger value="observations" data-e2e="observations-trigger">
        {t('observations')}
        <Badge size="xs">{sequence.observations?.length || 0}</Badge>
      </Tabs.Trigger>

      <Tabs.Trigger value="history" data-e2e="history-trigger">
        {t('history')}
      </Tabs.Trigger>
    </Tabs.List>
  )
}
